import ShoppingListService from "../../services/shoppingList.service";
import PurchaseHistoryService from "../../services/purchaseHistory.service";

// auxilary functions
// function saveShoppingList(errorElement, currentUser, items) {
export async function saveShoppingList( currentUser, items) {
  const errorElement = document.getElementById("error");
  // const errorElement = document.getElementById("error");
  // console.log("saveShoppingList: items ", items);
  // console.log("notes: ", notes);
  // console.log("postShoppingList()/saveShoppingList() ", currentUser);

  // just replace the list of todos, i.e. the tasks
  // console.log("todo.current: ", todo.current);

  ShoppingListService.postShoppingList(currentUser, items).then(
    async (response) => {
      // console.log(response.data);
      // console.log(response.status);
      // console.log("postShoppingList() ", response.statusText);
      // console.log("postShoppingList() ", response.data.message);
      // console.log("postShoppingList() ", response.data);
      // console.log("postShoppingList() ", errorElement);
      // console.log(response.headers);
      // console.log(response.config);
      if (errorElement) {
        errorElement.hidden = false;
        errorElement.style.color = "black";
        errorElement.style.display = "block"; // "none";
        errorElement.innerText =
          "Server's answer: " +
          response.data.message;
      }
      return response.data.message;
    },
    (error) => {
      const _content =
        (error.message ||
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.toString();
      if (errorElement) {
        errorElement.hidden = false;
        errorElement.innerText = _content;
      }
      // console.log("error ", error);
      // console.log("error.message ", error.message);
      // console.log("error.toString() ", error.toString());
      // console.log("error.response ", error.response);
      // console.log("error.response.data ", error.response.data);
      // console.log("error.response.data.message ", error.response.data.message);
      // console.log("_content ", _content);
      // console.log("errorElement ", errorElement);
      return _content;
    }
  );
}

// auxilary functions
// function savePurchaseHistory(errorElement, currentUser, items) {
export function savePurchaseHistory( currentUser, items) {
  const errorElement = document.getElementById("error");
  // const errorElement = document.getElementById("error");
  // console.log("savePurchaseHistory: items ", items);
  // console.log("notes: ", notes);
  // console.log("postPurchaseHistory()/savePurchaseHistory() ", currentUser);

  // just replace the list of todos, i.e. the tasks
  // console.log("todo.current: ", todo.current);

  PurchaseHistoryService.postPurchaseHistory(currentUser, items).then(
    (response) => {
      // console.log(response.data);
      // console.log(response.status);
      // console.log("postPurchaseHistory() ", response.statusText);
      // console.log("postPurchaseHistory() ", response.data.message);
      // console.log("postPurchaseHistory() ", response.data.message);
      // console.log("postPurchaseHistory() ", errorElement);
      // console.log(response.headers);
      // console.log(response.config);
      if (errorElement) {
        errorElement.hidden = false;
        errorElement.style.color = "black";
        errorElement.style.display = "block"; // "none";
        errorElement.innerText = response.data.message;
      }
      return response.data.message;
    },
    (error) => {
      const _content =
        (error.message ||
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.toString();
      if (errorElement) {
        errorElement.hidden = false;
        errorElement.innerText = _content;
      }
      // console.log("error ", error);
      // console.log("error.message ", error.message);
      // console.log("error.toString() ", error.toString());
      // console.log("error.response ", error.response);
      // console.log("error.response.data ", error.response.data);
      // console.log("error.response.data.message ", error.response.data.message);
      // console.log("_content ", _content);
      // console.log("errorElement ", errorElement);
      return _content;
    }
  );
}
